export default [
  {
    text: 'tipo',
    value: 'payment_type',
    align: 'center',
    component: {
      type: 'chip-label',
      props: {
        small: true,
      }
    },
  },
  {
    text: 'Cuenta',
    value: 'account_number',
  },
  {
    text: 'Plaza',
    value: 'plaza',
  },
  {
    text: 'Cargo',
    value: 'charge_date',
  },
  {
    text: 'Serie',
    value: 'serial_number',
  },
  {
    text: 'monto',
    value: 'amount',
    format: 'currency',
    align: 'right',
    input: {
      type: 'currency-field',
      reverse: true,
    },
    width: '15%',
  },
]